export default "__VITE_PUBLIC_ASSET__45f68f2f__"